import { Component, DestroyRef, inject, input, output, PLATFORM_ID, signal } from '@angular/core';
import { JobDetails, MoreJobsData, MoreJobsPayload } from '../../models/details.model';
import { AdsPanel } from "../../../jobs/components/ads-panel/ads-panel";
import { DatePipe, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { MoreJobsModal } from "../more-jobs-modal/more-jobs-modal";
import { Cookies, SharedItem } from '../../../../shared/enums/app.enums';
import { JobDetailService } from '../../services/job-details.service';
import { CookieService } from '../../../../core/services/cookie/cookie.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoModule } from '@jsverse/transloco';
import { ToBanglaNumberPipe } from '../../../../shared/pipes/toBanglaNumber.pipe';
import { RouterLink } from '@angular/router';
import { JOBS_URL } from '../../../../shared/consts/shared.const';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-newspaper-job-details',
  imports: [AdsPanel, DatePipe, MoreJobsModal, TranslocoModule, ToBanglaNumberPipe, RouterLink],
  templateUrl: './newspaper-job-details.html',
  styleUrl: './newspaper-job-details.scss'
})
export class NewspaperJobDetails {
  private platformId = inject(PLATFORM_ID)
  private isBrowser = isPlatformBrowser(this.platformId)
  private jobDetailsService = inject(JobDetailService)
  private cookieService = inject(CookieService)
  private destroyRef = inject(DestroyRef)
  jobDetails = input<JobDetails | null>(null);
  readonly jobList = input<MoreJobsData[]>()
  moreJobs = signal<MoreJobsData[]>([])
  callMoreJobsApi = output()
  isMoreJobModalOpen = signal(false)
  jobs_url = JOBS_URL
  deviceType:string = SharedItem.DEVICE
  encoded:string = SharedItem.ENCODED
  alias_status:number = SharedItem.ALIAS_STATUS
  environment = environment;
  readonly mybdjobsCookie = decodeURIComponent(this.cookieService.getCookie(Cookies.MyBDJOBSUSERID) ?? '');

  offeredJob(){
    if (this.moreJobs().length === 0) {
      const payload: MoreJobsPayload = {
        deviceType: this.deviceType,
        formValue: this.mybdjobsCookie,
        Company_ID: this.jobDetails()?.CompanyID || '',
        Company_Name: this.jobDetails()?.CompnayName || '',
        Alias_Status: this.alias_status,
      };
      this.jobDetailsService
        .getMoreJobsFromCompanies(payload)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (moreJobs: MoreJobsData[]) => {
            this.moreJobs.set(moreJobs);
          },
          error: (error) => {
            console.error(error);
          },
        });
    }
  }
  openMoreJobModal(){
    this.offeredJob()
    this.isMoreJobModalOpen.set(true)
    if(this.isBrowser){
      document.body.style.overflow = 'hidden'
    }
  }
  closeMoreJobModal(){
    this.isMoreJobModalOpen.set(false)
    if(this.isBrowser){
      document.body.style.overflow = ''
    }
  }
}
